/** *******************************************************************************************************************
  Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
  
  Licensed under the Apache License, Version 2.0 (the "License").
  You may not use this file except in compliance with the License.
  You may obtain a copy of the License at
  
      http://www.apache.org/licenses/LICENSE-2.0
  
  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.                                                                              *
 ******************************************************************************************************************** */
import React, { FunctionComponent } from 'react';
import { useHistory } from 'react-router-dom';
import Container from 'aws-northstar/layouts/Container';
import FormRenderer, { componentTypes, validatorTypes } from 'aws-northstar/components/FormRenderer';
import PreAnaesthesiaChecklist from './components/anaesthesia';
import PreIncisionChecklist from './components/incision'
import PreSurgicalChecklist from './components/postsurgical'
import Stack from 'aws-northstar/layouts/Stack';
import ColumnLayout, { Column } from 'aws-northstar/layouts/ColumnLayout';


const SurgicalChecklist: FunctionComponent = () => {
    const history = useHistory();
    return ( 
    <Stack>
            
            <PreAnaesthesiaChecklist />
            <PreIncisionChecklist />
            <PreSurgicalChecklist/>
        </Stack>);
};

export default SurgicalChecklist;
